import React, { memo, useCallback } from 'react';

import ModalFormWrapper from '@sharedCR/coreDesignSystem/ModalFormWrapper';
import { TextFieldCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import useForm from 'hooks/useForm';

import {
  REASON_FIELD_NAME,
  REASON_INPUT_PROPS,
  REASON_MAX_LENGTH,
  REASON_ROWS,
} from './LoanInfoHeader.constants';
import { ReasonFormTestIds } from './ReasonForm.testIds';

const ReasonForm = ({
  isLoading,
  formRef,
  onSubmit,
  label = 'Reason',
  submitButtonName = 'Submit',
  formTestId = 'reason-prompt-form',
  inputTestId = ReasonFormTestIds.REASON_INPUT,
  submitButtonTestId,
  isRequired = false,
}) => {
  const { form, handleChange } = useForm({});
  const reason = form.reason?.trim() || null;

  const onSubmitForm = useCallback(
    e => {
      e.preventDefault();
      onSubmit(reason);
    },
    [reason, onSubmit],
  );

  return (
    <ModalFormWrapper
      isFormChanged
      formRef={formRef}
      formTestId={formTestId}
      isSubmitButtonDisabled={isRequired && !reason}
      isSubmitting={isLoading}
      submitButtonName={submitButtonName}
      submitButtonTestId={submitButtonTestId}
      onSubmit={onSubmitForm}
    >
      <TextFieldCDS
        multiline
        dataTestId={inputTestId}
        disabled={isLoading}
        inputProps={REASON_INPUT_PROPS}
        label={label}
        maxLength={REASON_MAX_LENGTH}
        name={REASON_FIELD_NAME}
        required={isRequired}
        rows={REASON_ROWS}
        value={form.reason ?? ''}
        onChange={handleChange}
      />
    </ModalFormWrapper>
  );
};

ReasonForm.propTypes = {
  ...WithLoadingPropTypes,
  onSubmit: PropTypes.func.isRequired,
  label: PropTypes.string,
  submitButtonName: PropTypes.string,
  formTestId: PropTypes.string,
  inputTestId: PropTypes.string,
  submitButtonTestId: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default compose(withLoading, memo)(ReasonForm);
